import {Injectable} from "@angular/core";

@Injectable()
export class NewDeterminantHelperService {

  private selectedObject: any;
  private parentObject: any;

  get selectedObj(): any {
    return this.selectedObject;
  }

  set selectedObj(selectedObject: any) {
    this.selectedObject = selectedObject;
  }

  get parentObj(): any {
    return this.parentObject;
  }

  set parentObj(parentObject: any) {
    this.parentObject = parentObject;
  }

  public cleanData() {
    this.selectedObject = undefined;
    this.parentObject = undefined;
  }
}
